// extracted by mini-css-extract-plugin
export var addressFields = "_ib-0";
export var animationContainer = "_ib-1";
export var footer = "_ib-2";
export var lineItems = "_ib-3";
export var modalContent = "_ib-4";
export var orderName = "_ib-5";
export var strong = "_ib-6";
export var warning = "_ib-7";